import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../mock";
import { Icon, Reveal } from "./shared";

// Image cards (title + short) — used on Home & Industries pages
export function SimpleServiceGrid() {
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {SERVICES.map((s, i) => (
        <Reveal key={s.slug} delay={i * 80}>
          <Link
            to={`/services/${s.slug}`}
            className="svc-card group block h-full bg-white rounded-2xl overflow-hidden border border-black/5 shadow-sm hover:shadow-xl transition-shadow"
          >
            <div className="relative h-52 overflow-hidden">
              <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <div className="absolute top-4 left-4 w-9 h-9 rounded-full bg-white/85 backdrop-blur flex items-center justify-center">
                <Icon name={s.icon} className="w-4 h-4 text-[#0b2545]" />
              </div>
              <ArrowRight className="absolute top-4 right-4 w-5 h-5 text-white -rotate-45 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <div className="p-6">
              <h3 className="font-display font-bold text-[19px] text-[#0b2545]">{s.title}</h3>
              <p className="mt-3 text-[14px] text-slate-500 leading-relaxed">{s.short}</p>
            </div>
          </Link>
        </Reveal>
      ))}
    </div>
  );
}

// Detailed cards (with bullet lists) — used on Services listing page
export function DetailedServiceGrid() {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {SERVICES.map((s, i) => (
        <Reveal key={s.slug} delay={i * 80} className="h-full">
          <div className="svc-card h-full bg-white rounded-2xl overflow-hidden border border-black/5 shadow-sm hover:shadow-xl transition-shadow flex flex-col">
            <div className="relative h-48 overflow-hidden">
              <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <Link to={`/services/${s.slug}`} className="absolute top-4 left-4 w-9 h-9 rounded-full bg-white/85 backdrop-blur flex items-center justify-center">
                <Icon name={s.icon} className="w-4 h-4 text-[#0b2545]" />
              </Link>
              <Link to={`/services/${s.slug}`} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-white/85 backdrop-blur flex items-center justify-center">
                <ArrowRight className="w-4 h-4 text-[#0b2545] -rotate-45" />
              </Link>
            </div>
            <div className="p-6 flex flex-col flex-1">
              <Link to={`/services/${s.slug}`}>
                <h3 className="font-display font-bold text-[19px] text-[#0b2545] hover:text-[#14b8a6] transition-colors">{s.title}</h3>
              </Link>
              <p className="mt-3 text-[14px] text-slate-500 leading-relaxed">{s.short}</p>
              <div className="mt-5 pt-5 border-t border-black/5">
                <ul className="space-y-2.5">
                  {s.bullets.slice(0, 5).map((b, idx) => (
                    <li key={idx} className="flex items-start gap-2.5 text-[14px] text-slate-600">
                      <span className="mt-2 w-1 h-1 rounded-full bg-[#14b8a6] shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
